import {Link as PrimerLink} from '@primer/react-brand'
import {ArrowUpRightIcon} from '@primer/octicons-react'
import {clsx} from 'clsx'
import {getAnalyticsEvent} from '@github-ui/swp-core/lib/utils/analytics'

import Styles from './Link.module.css'

type Props = {
  href: string
  text: string
  showIcon?: boolean
  className?: string
  location: string
}

export function Link(props: Props) {
  const {href, text, showIcon = true, className, location} = props

  return (
    <PrimerLink
      className={clsx(Styles.Link, className)}
      href={href}
      variant="accent"
      arrowDirection="none"
      {...getAnalyticsEvent({
        action: text,
        tag: 'a',
        context: 'link',
        location,
      })}
    >
      {text}
      {showIcon && <ArrowUpRightIcon className={Styles.Icon} />}
    </PrimerLink>
  )
}
